import { TopMenuService } from "./shared/components/top-menu/top-menu.service";
import { AuthenticationService } from './core/services';
import { Renderer2, ElementRef } from '@angular/core';
import { EventAggregator } from './core/event-aggregator/event.aggregator';
import { MessageSentEvent } from './core/event-aggregator/events/message.sent.event';
import { HxEvent } from './core/event-aggregator/events/event';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalVariables } from './core/services/global.variables';
import { environment } from '../environments/environment';
import { ApiService } from './core/services/api.service';
import * as _moment from 'moment';
var moment = _moment;
var AppComponent = /** @class */ (function () {
    function AppComponent(authenticationService, eventAggregator, globalVariables, router, route, renderer, el, topMenuService, apiService) {
        var _this = this;
        this.authenticationService = authenticationService;
        this.eventAggregator = eventAggregator;
        this.globalVariables = globalVariables;
        this.router = router;
        this.route = route;
        this.renderer = renderer;
        this.el = el;
        this.topMenuService = topMenuService;
        this.apiService = apiService;
        this.migrated = false;
        this.newDashboardUrl = "https://oneview.hexoskin.com/";
        this.onMessageReceived = function (payload) {
            var that = _this;
            if (payload.object.msg === HxEvent.MAIN__FULL_SCREEN) {
                that.renderer.removeClass(_this.el.nativeElement, 'partial-main');
                that.renderer.addClass(_this.el.nativeElement, 'full-main');
            }
            else if (payload.object.msg === HxEvent.MAIN__PARTIAL_SCREEN) {
                that.renderer.removeClass(_this.el.nativeElement, 'full-main');
                that.renderer.addClass(_this.el.nativeElement, 'partial-main');
                /*} else if (payload.object.msg === HxEvent.ERROR) {
                    this.displayError(payload.object.text);*/
            }
            else if (payload.object.msg === 401) {
                _this.authenticationService.logout().subscribe(function () {
                    _this.router.navigate(['/']);
                });
            }
            else if (payload.object.msg === HxEvent.LOGOUT) {
                localStorage.clear(); // clear all data in localstorage
                window.location.href = environment.apiURL + '/api/connect/logout/'; // explicit logout from the serveur
            }
        };
    }
    AppComponent.prototype.childEventClicked = function (boxes) {
        this.boxes = boxes;
    };
    AppComponent.prototype.ngOnInit = function () {
        this.env = environment;
        console.log(this.env);
        // A logout initiated from another dashboard (e.g. OneView) redirects
        // here with `logout=1` instead of going through this app's own
        // logout flow, so our locally-stored auth state is never cleared on
        // that path. Clear it here when we detect the flag.
        if (this.route.snapshot.queryParamMap.get('logout') === '1') {
            this.authenticationService.clearLocalStorage();
        }
        // set a user context for Sentry
        if (this.authenticationService.isLoggedIn()) {
            this.topMenuService.showNavBar(true);
            this.fetchMigrationStatus();
        }
        else {
            this.topMenuService.showNavBar(false);
            // todo login
        }
        this.renderer.addClass(this.el.nativeElement, 'partial-main');
        this.eventAggregator.getEvent(MessageSentEvent).subscribe(this.onMessageReceived);
    };
    AppComponent.prototype.fetchMigrationStatus = function () {
        var _this = this;
        var currentUser = this.globalVariables.get('currentUser');
        var profileId = currentUser && currentUser.profile && currentUser.profile.id;
        if (!profileId)
            return;
        this.apiService.getFromUri('api/profile/' + profileId + '/').subscribe(function (profile) {
            _this.migrationDate = profile && profile.migration_date;
            _this.migrated = !!(profile && profile.migrated);
            _this.migratedAt = profile && profile.migrated_at;
        }, function () { });
    };
    Object.defineProperty(AppComponent.prototype, "isUrgent", {
        get: function () {
            if (!this.migrationDate)
                return false;
            var daysLeft = moment(this.migrationDate).startOf('day').diff(moment().startOf('day'), 'days');
            return daysLeft <= AppComponent.URGENT_THRESHOLD_DAYS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "isInGracePeriod", {
        get: function () {
            if (!this.migrated || !this.migratedAt)
                return false;
            return moment().isBefore(this.gracePeriodEnd);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "isLocked", {
        get: function () {
            return this.migrated && !this.isInGracePeriod;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "gracePeriodEnd", {
        get: function () {
            return moment(this.migratedAt).add(AppComponent.GRACE_PERIOD_DAYS, 'days');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "migrationBannerText", {
        get: function () {
            if (this.isInGracePeriod) {
                var formattedDate_1 = this.gracePeriodEnd.format('MM/DD/YYYY');
                return "Your account has been migrated to the new platform at " + this.newDashboardUrl + ". This dashboard is now read-only and will be disabled on " + formattedDate_1 + ".";
            }
            if (!this.migrationDate)
                return null;
            var formattedDate = moment(this.migrationDate).format('MM/DD/YYYY');
            return this.isUrgent
                ? "This dashboard will be replaced by a new version very soon, on " + formattedDate + ". Starting that date, you will need to use " + this.newDashboardUrl + " to access your data \u2014 no action is required from you before then."
                : "This dashboard will be replaced by a new version on " + formattedDate + ". Starting that date, you will need to use " + this.newDashboardUrl + " to access your data \u2014 no action is required from you before then.";
        },
        enumerable: true,
        configurable: true
    });
    AppComponent.URGENT_THRESHOLD_DAYS = 7;
    AppComponent.GRACE_PERIOD_DAYS = 14;
    return AppComponent;
}());
export { AppComponent };
